export const evtColors = {
  primary: "#1F39D9",
  white: "#FFFFFF",
  black: "#000000",
  normal: "#1D97B9",
  success: "#1DB954",
  successDark: "#166933",
  warning: "#E09B24",
  error: "#EE0224",
  brand: {
    900: "#0000B1",
    800: "#001FC2",
    700: "#0E2CCD",
    600: "#1F39D9",
    500: "#2441E4",
    400: "#4F60EB",
    300: "#727EEF",
    200: "#9DA2F3",
    100: "#C5C7F8",
    50: "#E8E9FC"
  },
  neutral: {
    900: "#000000",
    800: "#262626",
    700: "#434343",
    600: "#555555",
    500: "#7B7B7B",
    400: "#9D9D9D",
    300: "#C4C4C4",
    200: "#D9D9D9",
    100: "#E9E9E9",
    50: "#F5F5F5"
  },
  alert: {
    900: "#C20005",
    800: "#D00016",
    700: "#DC001E",
    600: "#EE0224",
    500: "#FD1C23",
    400: "#F83C42",
    300: "#EE6669",
    200: "#F69293",
    100: "#FFC9CF",
    50: "#FFE9ED"
  }
}
